import { Cell, Chip, Headline, styled, Text } from '@zeiss/beyond-online-react';
import { Box, Grid } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';

import { BaseProps } from './';
import { ApplicationCard } from 'src/modules/TenantManagement/components/ApplicationCard';
import { getUserInformation } from 'src/modules/TenantManagement/components/UserSearch';

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--spacing-responsive-s);
`;

const StyledText = styled(Text)`
  margin: 0;
`;

const OwnersContainer = styled.div`
  display: flex;
  gap: var(--spacing-responsive-s);
`;

export const Summary = ({ state }: Pick<BaseProps, 'state'>) => {
  const { t } = useTranslation(['common']);

  const { applications, owners } = state;

  return (
    <>
      <Box as="section">
        <StyledHeadline
          headline={t('common:glossary.application_other')}
          size="xs"
        />
        <Grid>
          {applications.length ? (
            applications.map(({ id, name, zeissDepartment }) => (
              <Cell.Basic colSpan={[4, 6, 5, 4]} key={id}>
                <ApplicationCard
                  department={zeissDepartment}
                  id={id}
                  name={name}
                  readonly
                />
              </Cell.Basic>
            ))
          ) : (
            <Cell.MaxWidth>
              <StyledText>
                {t('common:emptyState.textNoXdefined', {
                  x: t('common:glossary.application_other'),
                })}
              </StyledText>
            </Cell.MaxWidth>
          )}
        </Grid>
      </Box>

      <Box as="section">
        <StyledHeadline headline={t('common:glossary.owner_other')} size="xs" />

        <OwnersContainer>
          {owners.length ? (
            owners.map((owner) => (
              <Chip
                color="gray"
                fill="strong"
                key={owner.id}
                label={getUserInformation({ t, user: owner })}
                shape="rectangular"
                size="xs"
              />
            ))
          ) : (
            <StyledText>
              {t('common:emptyState.textNoXdefined', {
                x: t('common:glossary.owner_other'),
              })}
            </StyledText>
          )}
        </OwnersContainer>
      </Box>
    </>
  );
};
